import React from 'react';
import { Container } from 'react-bootstrap';
import skills from '../../data/skills';
import { useLanguage } from '../../context/LanguageContext';
import './style.scss';

const SKILL_GROUP_ORDER = [
  'languages',
  'frameworks',
  'tools',
  'service',
  'versionControl',
  'testing',
  'projectManagement',
  'communication',
  'other',
];

const SectionSkills = () => {
  const { t } = useLanguage();

  return (
    <section id="skills" className="section-skills">
      <Container className="section-skills__container section-container">
        <h2 className="section-title section-title--light">{t('skills.title')}</h2>

        {SKILL_GROUP_ORDER.map((key) => (
          <div key={key} className="section-skills__group">
            <h3 className="section-skills__group-title">{t(`skills.${key}`)}</h3>
            <div className="section-skills__chips">
              {skills[key].map((skill) => (
                <span key={skill} className="section-skills__chip">
                  {skill}
                </span>
              ))}
            </div>
          </div>
        ))}
      </Container>
    </section>
  );
};

export default SectionSkills;
